export default __webpack_public_path__ + "static/logo_banner-292181594b7c2bd5f6c86a43cc658ad8.png";